import LeftNavLink from "./LeftNavLink";

export default function LeftNavSubmenuItem(props) {
  const { item, insideRouter } = props;
  return (
    <LeftNavLink item={item} insideRouter={insideRouter}>
      <span>{item.label}</span>
    </LeftNavLink>
  );
}
